<script setup>
const props = defineProps({
  title: {
    type: String,
    default: 'IntegrateMe'
  },
  message: {
    type: String,
    default: 'Simplifying Onboarding'
  },
  showLogo: {
    type: Boolean,
    default: true
  },
});
</script>

<template>
  <div class="loading-splash">
    <div class="splash-content">
      <div v-if="showLogo" class="logo-container">
        <img
          src="/assets/images/logo-integrate-me.png"
          alt="IntegrateMe"
          class="logo"
        />
      </div>
      <div class="spinner-container">
        <div class="spinner" />
      </div>
      <div class="text-container">
        <h2 v-if="title" class="splash-heading">{{ title }}</h2>
        <p v-if="message" class="splash-text">{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.loading-splash {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
  overflow: hidden;
  transition: opacity 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
}

.splash-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
  padding: 2rem;
  opacity: 1;
  transform: scale(1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.logo-container {
  margin-bottom: 2rem;
  transform: translateY(0);
  opacity: 1;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
}

.logo {
  width: 180px;
  height: auto;
  object-fit: contain;
}

.spinner-container {
  position: relative;
  width: 60px;
  height: 60px;
  margin: 1rem 0;
}

.spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(0, 126, 79, 0.1);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  will-change: transform;
}

.spinner:nth-child(2) {
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  animation-delay: 0.1s;
  opacity: 0.7;
}

.spinner:nth-child(3) {
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  animation-delay: 0.2s;
  opacity: 0.4;
}

.text-container {
  margin-top: 1.5rem;
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s forwards;
}

.splash-heading {
  color: var(--text);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.splash-text {
  color: var(--text-light);
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .splash-content {
    padding: 1.5rem;
  }

  .logo {
    width: 150px;
  }

  .spinner-container {
    width: 50px;
    height: 50px;
  }

  .splash-heading {
    font-size: 1.25rem;
  }

  .splash-text {
    font-size: 0.9375rem;
  }
}
</style>
